import ModalFactory from '../factory';

import Content from './DTMFModal';

const DTMFModal = ModalFactory(Content);

export default DTMFModal;
